import React from 'react';
import styled from 'styled-components';
import Reveal from './Reveal';
import { text } from '../../styles/GlobalStyles';

const Rule = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 28px;
  font-size: ${text.xs};
  font-variant-numeric: tabular-nums;
  color: ${props => props.theme.colors.textTertiary};

  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: ${props => props.theme.colors.border};
  }
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  align-items: end;
  gap: 24px 64px;
  margin-bottom: 64px;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    grid-template-columns: minmax(0, 1fr);
    margin-bottom: 44px;
  }
`;

const Title = styled.h2`
  font-size: ${text.xxl};
  font-weight: 600;
  letter-spacing: -0.03em;
  line-height: 1.08;
  color: ${props => props.theme.colors.text};
  text-wrap: balance;
`;

const Subtitle = styled.p`
  max-width: 46ch;
  font-size: ${text.base};
  line-height: 1.6;
  color: ${props => props.theme.colors.textSecondary};
  text-wrap: pretty;
`;

interface SectionHeaderProps {
  index: number;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ index, title, subtitle }) => (
  <Reveal>
    <Rule>{String(index).padStart(2, '0')}</Rule>
    <Row>
      <Title>{title}</Title>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </Row>
  </Reveal>
);

export default SectionHeader;
